import { isNotBlank, isOneOf, isPresent, validateAll, validateAndLogOnErrors, validateField } from '../validation';
import { AggregationResponseOut, BucketEntryOut } from '../../store/api';
import { AggregationBucket, Aggregations } from '../../../models/Aggregations';
import { mapValidItems } from '../mapping';

const validateKey = validateAll(isPresent, isNotBlank);
const validateValue = validateAll(isNotBlank);
const validateState = validateAll(isOneOf(undefined, 'include', 'exclude'));
const aggregationBucketValidation = validateAll<BucketEntryOut>(
    validateField('key', validateKey),
    validateField('value', validateValue),
    validateField('state', validateState)
);
const isBucketValid = (bucket: BucketEntryOut): boolean => {
    return validateAndLogOnErrors(aggregationBucketValidation, bucket);
};
const mapAggreationBucket = (buckets?: ReadonlyArray<BucketEntryOut>): ReadonlyArray<AggregationBucket> => {
    if (!buckets) {
        return [];
    }

    return mapValidItems(buckets, isBucketValid, entry => ({
        key: entry.key!,
        value: entry.value!,
        custom: entry.custom ?? false,
        customIndex: entry.customIndex ?? 0,
        docCount: entry.docCount ?? 0,
        state: entry.state ?? '',
        buckets: mapAggreationBucket(entry.buckets)
    }));
};
export const mapAggregations = (resp: AggregationResponseOut): Aggregations => {
    if (!resp.aggregations) {
        return {};
    }
    return Object.keys(resp.aggregations).reduce<Aggregations>((aggregations, category) => {
        const aggregation = resp.aggregations![category];

        aggregations[category] = {
            buckets: aggregation.buckets ? mapAggreationBucket(aggregation.buckets) : undefined,
            more: aggregation.more ?? false,
            quicksearchQuery: aggregation.quicksearchQuery ?? '',
            value: aggregation.value ?? ''
        };
        return aggregations;
    }, {});
};
